import script from "./LegendList.vue?vue&type=script&setup=true&lang=js"
export * from "./LegendList.vue?vue&type=script&setup=true&lang=js"

import "./LegendList.vue?vue&type=style&index=0&id=3ee69d66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ee69d66"]])

export default __exports__